function addShareButtons(shareButton) {
    const activeButton = document.querySelector('.js-article__share-button')
    const element = document.querySelector('.js-article__share-container')
    shareButton.addEventListener('click', function () {
        element.classList.toggle('article__open')
        activeButton.classList.toggle('active')
    })

    document.addEventListener('click', function (event) {
        const isClickInside = element.contains(event.target)

        if (!isClickInside && event.target !== shareButton) {
            element.classList.remove('article__open')
            activeButton.classList.remove('active')
        }
    })
}
export function initShareButtons() {
    const shareButton = document.querySelector('.js-article__share-button')
    if (shareButton) {
        addShareButtons(shareButton)
    }
}

export function initPageShareArticle() {
    const shares = document.querySelectorAll('.js-article__share')
    shares.forEach((share) => {
        const shareBtn = document.querySelector('.js-author-sidebar__share-button')
        const closeBtn = document.querySelector('.article__share-close-btn')

        shareBtn.addEventListener('click', () => {
            share.classList.add('article__share--active')
        })

        closeBtn.addEventListener('click', () => {
            share.classList.remove('article__share--active')
        })
    })
}

if (document.readyState !== 'loading') {
    initShareButtons()
    initPageShareArticle()
} else {
    document.addEventListener('DOMContentLoaded', () => {
        initShareButtons()
        initPageShareArticle()
    })
}
